import { Component } from '@angular/core';

@Component({
  selector: 'app-accusion-engineering-pvt-ltd',
  templateUrl: './accusion-engineering-pvt-ltd.component.html',
  styleUrls: ['./accusion-engineering-pvt-ltd.component.scss']
})
export class AccusionEngineeringPvtLtdComponent {

}
